import template from './acris-blog-group-detail.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('acris-blog-group-detail', {
    template,

    inject: [
        'repositoryFactory',
        'context'
    ],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            item: null,
            isLoading: false,
            processSuccess: false,
            repository: null,
            isSaveSuccessful: false
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        groupRepository() {
            return this.repositoryFactory.create('acris_blog_group');
        },

        groupCriteria() {
            return new Criteria();
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.repository = this.repositoryFactory.create('acris_blog_group');
            this.getEntity();
        },

        getEntity() {
            this.repository.get(this.$route.params.id, Shopware.Context.api, this.groupCriteria).then((entity) => {
                this.item = entity;
            });
        },

        onClickSave() {
            this.isLoading = true;
            this.isSaveSuccessful = false;

            this.repository.save(this.item, Shopware.Context.api).then(() => {
                this.getEntity();
                this.isLoading = false;
                this.processSuccess = true;
                this.createNotificationSuccess({
                    title: this.$tc('acris-blog-group.detail.titleSaveSuccess'),
                    message: this.$tc('acris-blog-group.detail.messageSaveSuccess')
                });
            }).catch(() => {
                this.isLoading = false;
                this.createNotificationError({
                    title: this.$tc('acris-blog-group.detail.titleSaveError'),
                    message: this.$tc('acris-blog-group.detail.messageSaveError')
                });
            });
        },

        onChangeLanguage() {
            this.getEntity();
        },

        onChangeBreadcrumbCategory(value) {
            this.item.breadcrumbCategoryId = value;
        },

        saveFinish() {
            this.processSuccess = false;
        }
    }
});

